import { Navigate, useLocation } from 'react-router-dom'
import { TrendingUp } from 'lucide-react'
import { useAuthStore } from '@/hooks/useAuthStore'

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuthStore()
  const location = useLocation()

  if (isLoading) {
    return (
      <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }} className="bg-bg animate-fade-in">
        <div
          style={{ width: 64, height: 64, borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          className="bg-primary/10"
        >
          <TrendingUp style={{ width: 36, height: 36 }} className="text-primary" />
        </div>
        <div
          style={{ width: 28, height: 28, borderWidth: 3, borderRadius: '50%' }}
          className="border-primary/30 border-t-primary animate-spin"
        />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
